'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import Markdown from '../../../Doc/components/Markdown';
import { jsx as _jsx } from "react/jsx-runtime";
export default class DescriptionField extends Component {
  render() {
    const {
      id,
      description
    } = this.props;
    const body = typeof description === 'string' ? /*#__PURE__*/_jsx(Markdown, {
      inline: true,
      breakWord: false,
      children: description
    }) : description;
    return /*#__PURE__*/_jsx("span", {
      id: id,
      children: body
    });
  }
}
DescriptionField.propTypes = {
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  id: PropTypes.string
};